import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useUserContext } from './UserContext';

const BackgroundContext = createContext();
const baseUrl = process.env.REACT_APP_API_URL;
const endpointBackgrounds = `${baseUrl}/background`;

export const BackgroundProvider = ({ children }) => {
  const { tokens } = useUserContext();
  const [backgrounds, setBackgrounds] = useState([]);
  const [loadingBackgrounds, setLoadingBackgrounds] = useState(true);
  const [errorBackgrounds, setErrorBackgrounds] = useState(null);

  const fetchBackgrounds = async () => {
    try {
      const token = tokens?.accessToken;
      if (!token) throw new Error('Token manquant');

      const response = await axios.get(endpointBackgrounds, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let urls = [];
      // Harmonisation du parsing
      if (response?.data?.body) {
        try {
          urls = JSON.parse(response.data.body);
        } catch (e) {
          console.error("[BackgroundContext] Erreur de parsing JSON:", e, "body reçu:", response.data.body);
          throw new Error("Erreur lors du parsing JSON de la réponse backgrounds.");
        }
      } else if (Array.isArray(response.data)) {
        urls = response.data;
      } else {
        console.warn("[BackgroundContext] Réponse backend inattendue :", response.data);
        throw new Error("Donnée de réponse background vide ou mal formatée.");
      }
      setBackgrounds(urls.map(item => item.url));
      // Si tu veux garder le key : setBackgrounds(urls)
      //console.log("[BackgroundContext] Backgrounds récupérés :", urls);

    } catch (err) {
      console.error('[BackgroundContext] Erreur:', err);
      setErrorBackgrounds(err.message || 'Erreur inconnue');
    } finally {
      setLoadingBackgrounds(false);
    }
  };

  useEffect(() => {
    if (tokens?.accessToken) {
      fetchBackgrounds();
    }
  }, [tokens]);

  return (
    <BackgroundContext.Provider value={{ backgrounds, loadingBackgrounds, errorBackgrounds }}>
      {children}
    </BackgroundContext.Provider>
  );
};

export const useBackgroundContext = () => useContext(BackgroundContext);
